module.exports = __webpack_public_path__ + "static/media/honor-img8.966fc584.png";